import { combineReducers } from 'redux';
import layoutReducer from '../features/layout/LayoutSlice';


const rootReducer = combineReducers({
    layout: layoutReducer,

    // Thêm các reducer khác vào đây
});

export default rootReducer;